<template>
    <div v-if="!loading">
        <div v-for="(section, index) in value" :key="`information-section-${index}`" class="information-section">
            <x-layout align-end>
                <x-flex xs6>
                    <h3>{{ section.name }}</h3>
                </x-flex>
                <template v-if="section.permissions">
                    <x-flex xs6 v-if="section.insurer_company_ids.length === 1">
                        Viewable by: {{ getInsurerName(section.permissions[0]) }}
                    </x-flex>
                    <x-flex xs6 v-else>
                        Viewable by: {{ numberOfInsurersSelected(section.insurer_company_ids) }}
                        <template v-if="section.insurer_company_ids.length > 0">
                            <x-btn outline @click="section.show_all_insurers = !section.show_all_insurers">{{ section.show_all_insurers ? 'Hide' : 'Show' }}</x-btn>
                            <template v-if="section.show_all_insurers">
                                <p v-for="(permission, index) in section.permissions" :key="`permission-insurer-${index}`">
                                    {{ getInsurerName(permission) }}
                                </p>
                            </template>
                        </template>
                    </x-flex>
                </template>
            </x-layout>

            <x-layout>
                <x-flex xs12>
                    <div class="text-editor-output" v-html="section.content" />
                </x-flex>
            </x-layout>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AdditionalInformationDisplay',
        props: {
            value: Array,
            facilityId: Number,
            insurerList: Array,
            insurer: Boolean,
        },
        data() {
            return {
                loading: true,
                insurers: []
            }
        },
        mounted() {
            this.getInsurers();
        },
        methods: {
            async getInsurers() {
                if (!this.insurer) {
                    if (this.insurerList && this.insurerList.length > 0) {
                        this.insurers = this.insurerList;
                    } else {
                        const url = this.facilityId ? `/api/insurer/facility/${this.facilityId}/captive/` : '/api/insurer';
                        await axios.get(url).then(res => {
                            this.insurers = res.data.data;
                        });
                    }

                    this.initialiseSections();
                }

                this.loading = false;
            },
            initialiseSections() {
                const insurerList = this.insurers;
                this.value.forEach(section => {
                    if (!section.permissions && section.insurer_company_ids && insurerList) {
                        section.permissions = section.insurer_company_ids.map(insurerId => {
                            return {
                                insurer_company_id: insurerId,
                                insurer_company: insurerList.find(insurer => insurer?.id === insurerId)
                            };
                        });
                    } else if (section.permissions) {
                        section.insurer_company_ids = section.permissions.map(permission => permission.insurer_company_id).filter(insurerId => {
                            return insurerList.find(insurer => insurer?.id === insurerId);
                        });
                    }

                    this.$set(section, 'show_all_insurers', false);
                });
            },
            numberOfInsurersSelected(selectedInsurers) {
                if (this.insurers.length === selectedInsurers.length) {
                    return 'All insurers';
                }

                return selectedInsurers.length + ' insurers';
            },
            getInsurerName(permission) {
                return permission.insurer_company?.name || permission.captive_insurer_company?.name || '';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .information-section + .information-section {
        margin-top: 48px;
        border-top: 1px dashed rgba(112, 112, 112, 0.5);
        padding-top: 48px;
    }

    .x-btn {
        height: 20px;
        font-size: rem(12px);
    }
</style>
